import { useRoutes } from "react-router-dom";
import DashboardLayout from "./layouts/DashboardLayout";
import PublicRoutesLayout from "./layouts/PublicRoutesLayout";
import ListUsers from "./pages/auth/ListUsers";
import AddUser from "./pages/auth/AddUser";

//import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Page404 from "./pages/page404";
import AddCategory from "./pages/category/AddCategory";
import ListCategories from "./pages/category/ListCategories";
import AddBlog from "./pages/blog/AddBlog";
import ListBlogs from "./pages/blog/ListBlogs";
import UpdUser from "./pages/auth/UpdUser";
import ListJobs from "./pages/jobs/ListJobs";
import AddTag from "./pages/tag/AddTag";
import ListTags from "./pages/tag/ListTags";
export default function Router() {
  return useRoutes([
    {
      path: "/app",
      element: <DashboardLayout />,
      children: [
        { path: "utilisateurs", element: <ListUsers /> },
        { path: "ajoute-utilisateur", element: <AddUser /> },
        { path: "changer-user/:id", element: <UpdUser /> },

        { path: "ajoute-blog", element: <AddBlog /> },
        { path: "list-blogs", element: <ListBlogs /> },

        { path: "ajoute-categorie", element: <AddCategory /> },
        { path: "list-categories", element: <ListCategories /> },

        { path: "ajoute-tag", element: <AddTag /> },
        { path: "list-tags", element: <ListTags /> },

        { path: "list-jobs", element: <ListJobs /> },
      ],
    },
    {
      path: "/",
      element: <PublicRoutesLayout />,
      children: [
        { index: true, element: <Login /> },
        { path: "page404", element: <Page404 /> },
      ],
    },
  ]);
}
